import { Avatar, Box, Button, FormControl, Grid, InputAdornment, IconButton, MenuItem, Select, TextField, Typography } from '@mui/material';
import { TEXT_TITLE_COLOR } from '../../constants/colors';
import { useFormJiffyStaffController } from './controller/form';
import SwitchComponent from '../../components/switch';
import { MerchantUserModel } from '../../models/merchantUser';
import ConfirmDialog from '../../components/ConfirmDialog';
import { ArrowBack, Visibility, VisibilityOff } from '@mui/icons-material';
import { MerchantUserEnum } from '../../enums/merchantUser';
import { useTranslation } from 'react-i18next';
import { ProvinceModel } from '../../models/province';
import { District } from '../../models/district';

interface Props {
  onClose: VoidFunction;
  selectedData: MerchantUserModel
  onFetchData: Function,
  setSelected: Function
  branchValue: string
  merchantType: MerchantUserEnum
}

const FormJiffyStaffView = ({ onClose, selectedData, onFetchData, setSelected, branchValue, merchantType }: Props) => {
  const controller = useFormJiffyStaffController({ onClose, selectedData, onFetchData, setSelected, branchValue, merchantType });
  const { t } = useTranslation("global");
  return (
    <form onSubmit={(e) => controller.handleOpenConfirmForm(e)}>
      <IconButton onClick={() => { onClose(); controller.handleRest() }}>
        <ArrowBack />
      </IconButton>
      <Typography variant="h5" fontWeight="bold" color={TEXT_TITLE_COLOR}>
        {selectedData ? t('merchantUser_page.Update Merchant User') : t('merchantUser_page.Create Merchant User')}
      </Typography>
      <Grid container spacing={2} mt={1}>
        <Grid item xs={4}>
          <Box
            sx={{
              paddingTop: 5,
              paddingBottom: 5,
              borderRadius: 5,
              boxShadow:
                '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
            }}
          >
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              <label htmlFor="image-input-admin">
                <Avatar
                  src={controller.imageToShow}
                  alt=""
                  style={{ cursor: 'pointer', width: 150, height: 150, objectFit: 'contain' }}
                />
              </label>
              <input
                type="file"
                id="image-input-admin"
                onClick={(e: any) => {
                  e.target.value = '';
                }}
                onChange={controller.handleSelectedImage}
                style={{ display: 'none' }}
              />
            </Box>
            <Box mt={2}>
              <Typography textAlign="center">Allowd *.jpeg,*.jpg,*.png</Typography>
              <Typography textAlign="center">Max size of 3.1 MB</Typography>
            </Box>
          </Box>
          {
            selectedData ? <Box
              sx={{ display: 'flex', justifyContent: 'center', mt: 1, alignItems: 'center', gap: 2 }}
            >
              <Typography>
                <span style={{ color: 'green' }}>{t("merchantUser_page.Active")}</span> / <span>{t("merchantUser_page.InActive")}</span>
              </Typography>
              <SwitchComponent value={controller.banValue} onChange={controller.handleBanUser} />
            </Box> : <Box></Box>
          }

        </Grid>
        <Grid item xs={8}>
          <Box
            sx={{
              p: 4,
              boxShadow:
                '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
              borderRadius: 5,
            }}
          >
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <Box sx={{ width: '100%' }}>
                  <Typography>{t("merchantUser_page.First name")}</Typography>
                  <TextField
                    fullWidth
                    placeholder='ປ້ອນຊື່'
                    margin='normal'
                    required
                    inputRef={controller.firstName}
                  />
                </Box>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Box sx={{ width: '100%' }}>
                  <Typography>{t("merchantUser_page.Last name")}</Typography>
                  <TextField
                    fullWidth
                    placeholder='ປ້ອນນາມສະກຸນ'
                    margin='normal'
                    required
                    inputRef={controller.lastName}
                  />
                </Box>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Box sx={{ width: '100%' }}>
                  <Typography>{t("merchantUser_page.Phone number")}</Typography>
                  <TextField
                    fullWidth
                    margin='normal'
                    placeholder='ປ້ອນເບີໂທລະສັບ'
                    required
                    inputRef={controller.tel}
                  />
                </Box>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Box sx={{ width: '100%' }}>
                  <Typography>{t("merchantUser_page.Email")}</Typography>
                  <TextField
                    fullWidth
                    margin='normal'
                    placeholder='ອີເມວ'

                    inputRef={controller.email}
                  />
                </Box>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Box sx={{ width: '100%' }}>
                  <Typography>{t("merchantUser_page.Province")}</Typography>
                  <FormControl fullWidth margin='normal'>
                    <Select value={controller.provinceValue} onChange={controller.handleSelectedProvince}>
                      {
                        controller.provinceData?.map((data: ProvinceModel) => (
                          <MenuItem key={data?.id} value={data?.provinceNameLA}>
                            {data?.provinceNameLA}
                          </MenuItem>
                        ))
                      }
                    </Select>
                  </FormControl>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Box sx={{ width: '100%' }}>
                  <Typography>{t("merchantUser_page.City")}</Typography>
                  <FormControl fullWidth margin='normal'>
                    <Select value={controller.districtsValue} onChange={controller.handleSelectedDistrict}>
                      {
                        controller.districtsData?.map((dis: District) => (
                          <MenuItem key={dis?.districtCode} value={dis?.districtNameLA}>
                            {dis?.districtNameLA}
                          </MenuItem>
                        ))
                      }
                    </Select>
                  </FormControl>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Box sx={{ width: '100%' }}>
                  <Typography>{t("merchantUser_page.Village")}</Typography>
                  <TextField
                    fullWidth
                    margin='normal'
                    placeholder='ບ້ານ'
                    required
                    inputRef={controller.village}
                  />
                </Box>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Box sx={{ width: '100%' }}>
                  <Typography>{t("merchantUser_page.Username")}</Typography>
                  <TextField
                    fullWidth
                    margin='normal'
                    placeholder='ປ້ອນຊື່ຜູ້ໃຊ້ງານ'
                    required
                    inputRef={controller.userName}
                    disabled={selectedData !== null}
                  />
                </Box>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Box sx={{ width: '100%' }}>
                  <Typography>{t("merchantUser_page.Password")}</Typography>
                  <TextField
                    fullWidth
                    type={controller.showPassword ? 'text' : 'password'}
                    margin='normal'
                    placeholder='ປ້ອນລະຫັດຜ່ານ'
                    inputRef={controller.password}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position='end'>
                          <IconButton
                            edge="end"
                            onClick={controller.handleShowPassword}
                            onMouseDown={(e) => e.preventDefault()}
                          >
                            {controller.showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      )
                    }}
                  />
                </Box>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Box sx={{ width: '100%' }}>
                  <Typography>{t("merchantUser_page.Confirm Password")}</Typography>
                  <TextField
                    fullWidth
                    type={controller.showConfirmPassword ? 'text' : 'password'}
                    margin='normal'
                    placeholder='ຢືນຢັນລະຫັດຜ່ານ'
                    inputRef={controller.confirmPassword}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position='end'>
                          <IconButton
                            edge="end"
                            onClick={controller.handleShowConfirmPassword}
                            onMouseDown={(e) => e.preventDefault()}
                          >
                            {controller.showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      )
                    }}
                  />
                </Box>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Box sx={{ width: '100%' }}>
                  <Typography>{t("merchantUser_page.Role")}</Typography>
                  <FormControl fullWidth margin="normal">
                    <Select value={controller.roleAndPermissionValue} onChange={(e) => controller.handleChangeRoleAndPermission(e.target.value)}>
                      {controller.roleAndPermissionData.map((option) => (
                        <MenuItem key={option.id} value={option.id}>
                          {t("merchantUser_page." + option.role_type)}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>
              </Grid>
            </Grid>
            {controller.errorMessage && <Typography color='error'>{controller.errorMessage}</Typography>}
            <Box mt={3} sx={{ display: 'flex', gap: 1, justifyContent: 'end' }}>
              <Button
                type="submit"
                variant="contained"
                color='secondary'
                sx={{ textTransform: 'none', width: 150, color: '#fff' }}
              >
                {
                  selectedData ? t('Update') : t('Create')
                }
              </Button>
            </Box>
          </Box>
        </Grid>
      </Grid>
      <ConfirmDialog
        open={controller.openConfirm}
        title={` ${selectedData ? t("merchantUser_page.Do you want to update this user ?") : t("merchantUser_page.Do you want to create this user ?")}`}
        loading={controller.loadingConfirmForm}
        onCancel={controller.handleCloseConfirmForm}
        onConfirm={() => controller.handleSubmit()}
      />
    </form>
  );
};
export default FormJiffyStaffView;
